// Determina l'environment del configuratore in base all'URL dello store.
// ducati-cycling.com -> prod, dmt-ducati.myshopify.com (default) -> dev
function getConfiguratorEnvironment() {
  const host = window.location.hostname;
  return host === 'ducati-cycling.com' || host === 'www.ducati-cycling.com' ? 'prod' : 'dev';
}

// Modello 3D aperto quando il bottone non ha data-model-id.
const DEFAULT_MODEL_ID = 'BSQKW7IOOK';

// Nuovo modello configurabile: aggiungere qui e in CUSTOMIZER_PRODUCT_HANDLES i codici
// dei suoi allestimenti (detail.productId) e i prezzi in snippets/configurator.liquid.
const CUSTOMIZER_VARIANT_IDS = {
  'M0013DC127MONOSCOCCA_ID_ID': '58233973113164',
  'M0012DC127MONOSCOCCA_ID-R_ID': '58233972982092',
  'M0012DC127MONOSCOCCA_ID-RR_ID': '58233973047628',
};

const CUSTOMIZER_PRODUCT_HANDLES = {
  'M0013DC127MONOSCOCCA_ID': 'ducati-monoscocca',
  'M0012DC127MONOSCOCCA_ID-R': 'ducati-monoscocca-r',
  'M0012DC127MONOSCOCCA_ID-RR': 'ducati-monoscocca-rr',
};

// Promise per handle: i popup di un prodotto vengono scaricati e iniettati una volta sola.
const sizeModalsRequests = {};

// listener su close / #confiroot registrati dalla prima istanza di button-configurator
let sharedListenersBound = false;

// Scarica sections/gdl-size-modals.liquid nel contesto del prodotto e lo appende al body.
function loadSizeModals(handle) {
  if (!sizeModalsRequests[handle]) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    sizeModalsRequests[handle] = fetch(`${root}products/${handle}?section_id=gdl-size-modals`)
      .then((response) => {
        if (!response.ok) throw new Error(`size modals HTTP ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const holder = document.createElement('div');
        holder.innerHTML = html;
        // innerHTML non esegue gli script: li ricreo cosi' partono all'append nel body
        // e registrano i custom element size-guide-modal / size-recommendation-modal.
        holder.querySelectorAll('script').forEach((oldScript) => {
          const script = document.createElement('script');
          script.textContent = oldScript.textContent;
          oldScript.replaceWith(script);
        });
        while (holder.firstChild) document.body.appendChild(holder.firstChild);
      })
      .catch((error) => {
        // niente cache di una fetch fallita: al prossimo click si riprova
        delete sizeModalsRequests[handle];
        throw error;
      });
  }
  return sizeModalsRequests[handle];
}

class Configurator extends HTMLElement {
  constructor() {
    super();

    this.closeConfiguratorBtn = document.getElementById("close_configurator");
    this.html = document.getElementsByTagName("html")[0];
    this.configuratorWrapper = document.getElementById("configurator-wrapper");
    this.configurator = document.getElementById("confiroot");

    this.addEventListener("click", () => {
      // prendo i dataset che ho assegnato a product_configurator in template--product
      let productConfiguration = this.dataset.productConfiguration;
      const productPrice = this.dataset.productPrice;

      let productIndex = "";
      let productQuantity = "";

      if (productConfiguration !== "") {
        // Splitta la stringa basata su '|' per ottenere i diversi gruppi
        const pairs = productConfiguration.split('|').filter(Boolean);
        // Crea l'array materials escludendo 'taglia'
        const materials = pairs
          .map(pair => {
            // Splitta ogni coppia sulla base di ':'
            const [key, value] = pair.split(':');
            // Escludi il gruppo 'taglia'
            if (key.toLowerCase() === 'taglia') return null;
            // Restituisce l'oggetto formattato
            return {
              groupName: key.toUpperCase(),
              configuration: { name: value }
            };
          })
          .filter(Boolean); // Filtra fuori i valori nulli
        productConfiguration = materials;
        productIndex = this.dataset.productIndex;
        productQuantity = this.dataset.productQuantity;
      }

      // chiamo la funzione che apre il configuratore
      this.init(
        productPrice,
        productConfiguration,
        productIndex,
        productQuantity
      );
    });

    // close e #confiroot sono unici in pagina: con piu' <button-configurator>
    // (es. gdl-configurator-banner con 2 bottoni) ogni istanza duplicherebbe
    // i listener -> unmount multipli, popup taglie aperti N volte.
    if (sharedListenersBound) return;
    sharedListenersBound = true;

    this.closeConfiguratorBtn.addEventListener("click", () => {
      this.onCloseConfigurator();
    });

    // Bottoni "See size table" / "Get size info" dentro il configuratore.
    // Qui e non in init(): #confiroot sopravvive a unmount(), i listener si
    // duplicherebbero a ogni riapertura.
    this.configurator.addEventListener("onOpenSizeChart", (event) => {
      this.openSizeModal(event, "SizeGuidePopup-");
    });

    this.configurator.addEventListener("onOpenSizeRecommendation", (event) => {
      this.openSizeModal(event, "SizeRecommendationPopup-");
    });
  }

  // Apre il popup taglie del prodotto indicato dall'evento, caricandolo se serve.
  async openSizeModal(event, idPrefix) {
    const detail = event.detail || {};
    const productId = detail.productId || this.dataset.productId;
    // onPurchase usa lo stesso id col suffisso "_ID": accetto entrambe le forme.
    const handle =
      CUSTOMIZER_PRODUCT_HANDLES[productId] ||
      CUSTOMIZER_PRODUCT_HANDLES[String(productId).replace(/_ID$/, "")];

    if (!handle) {
      console.error("Unknown configurator productId, cannot open size modal:", productId);
      return;
    }

    try {
      await loadSizeModals(handle);
    } catch (error) {
      console.error("Size modals failed to load:", error);
      return;
    }

    const modal = document.getElementById(idPrefix + handle);
    if (!modal || typeof modal.open !== "function") {
      console.error("Size modal not found:", idPrefix + handle);
      return;
    }
    modal.open();
  }

  init(
    productPrice,
    productConfiguration,
    productIndex,
    productQuantity,
    retryCount = 0
  ) {
    if (!window.ThreeDConfigurator) {
      if (retryCount < 20) {
        setTimeout(() => {
          this.init(productPrice, productConfiguration, productIndex, productQuantity, retryCount + 1);
        }, 500);
      } else {
        console.error("Configurator resources failed to load (timeout).");
        document.dispatchEvent(new CustomEvent("configuratorError", { detail: { reason: "timeout" } }));
      }
      return;
    }

    const allowedLangs = ["it", "fr", "es", "de", "en"];
    let language = document.getElementsByTagName("html")[0].lang;
    const langParam = new URLSearchParams(window.location.search).get("lang");
    if (langParam) {
      const normalizedLang = langParam.trim().toLowerCase();
      if (allowedLangs.includes(normalizedLang)) {
        language = normalizedLang;
      }
    }

    const modelId = this.dataset.modelId || DEFAULT_MODEL_ID;

    // prezzi degli allestimenti del modello aperto, resi da snippets/configurator.liquid:
    // sono i prezzi correnti dei prodotti nel market attivo, non hardcodati
    const marketPrices = (window.configuratorPrices || {})[modelId] || {};
    if (!window.configuratorPrices || !window.configuratorPrices[modelId]) {
      console.error("No configurator prices for model:", modelId);
    }

    let data = {
      theme: "light",
      lang: language,
      price: productPrice,
      kitPrice: marketPrices.kitPrice,
      rPrice: marketPrices.rPrice,
      rrPrice: marketPrices.rrPrice,
    };

    if (productConfiguration !== "") {
      data.materials = productConfiguration;
    }

    data.b2c = {
      enableFlags: true,
      enableText: true
    };
    // inizializzo il configuratore 3D
    try {
      window.ThreeDConfigurator.init('confiroot', {
        ...data,
        modelId,
        customProduct: this.dataset.customProduct || '',
        modelUrl: 'https://3dconfigurator.skillbill.net/api/',
        mode: 'b2c',
        client: 'ducati',
        environment: 'production'
      });
    } catch (error) {
      console.error("Configurator init failed:", error);
      document.dispatchEvent(new CustomEvent("configuratorError", { detail: { reason: "init", error } }));
      return;
    }
    window.ThreeDConfigurator.elementId = 'confiroot';

    // un solo onPurchase attivo: init() gira a ogni apertura e da qualunque bottone,
    // senza rimuovere il precedente ogni acquisto andrebbe a carrello N volte
    if (this.configurator._onPurchaseHandler) {
      this.configurator.removeEventListener("onPurchase", this.configurator._onPurchaseHandler, false);
    }
    this.configurator._onPurchaseHandler = (event) =>
      this.onPurchaseHandler(event, productIndex, productQuantity);
    this.configurator.addEventListener("onPurchase", this.configurator._onPurchaseHandler, false);

    this.configuratorWrapper.classList.add("visible");

    // mostro l'icona per chiudere il configuratore
    this.closeConfiguratorBtn.classList.add("visible");

    // blocco lo scroll sulla pagina
    this.html.classList.add("configurator--visible")
  }

  onCloseConfigurator() {
    // chiudo il configuratore, nascondo l'icona e riattivo lo scroll
    window.ThreeDConfigurator.unmount();
    this.closeConfiguratorBtn.classList.remove("visible");
    this.html.classList.remove("configurator--visible")
    this.configuratorWrapper.classList.remove("visible");
  }

  async onPurchaseHandler(event, productIndex, productQuantity) {
    const detail = event.detail;

    // l'allestimento scelto nel configuratore decide quale prodotto va a carrello
    const variantId = CUSTOMIZER_VARIANT_IDS[detail.productId];
    if (!variantId) {
      console.error("Unknown configurator productId, aborting add to cart:", detail.productId);
      return;
    }

    const properties = {};

    (detail.configuration || []).forEach((el) => {
      let name = el.groupName.toLowerCase();
      if (name.includes(" ")) {
        const splitName = name.split(" ");
        name =
          splitName[0] +
          splitName[1].charAt(0).toUpperCase() +
          splitName[1].slice(1);
      }

      properties[name] = el.configuration.name;
      properties[`_${name}`] = el.code;
    });

    properties.size = detail.size;

    const customDetail = detail.details && detail.details[0];
    if (customDetail) {
      if (customDetail.flag) properties.flag = customDetail.flag;
      if (customDetail.text) properties.text = customDetail.text;
    }

    if (detail.flagOutlineColor && detail.flagOutlineColor.code) {
      properties.flagOutlineColor = detail.flagOutlineColor.name;
      properties['_flagOutlineColor'] = detail.flagOutlineColor.code;
    }

    if (detail.textColor && detail.textColor.code) {
      properties.textColor = detail.textColor.name;
      properties['_textColor'] = detail.textColor.code;
    }

    properties._configuration = detail.configurationCode;
    properties._image = detail.image;
    properties._Model_id = detail.modelId;
    properties._Configuration_code = detail.hubspotConfigurationId;

    if (productIndex !== "") {
      this.updateProduct({
        id: variantId,
        line: productIndex,
        quantity: productQuantity,
        properties,
      });
    } else {
      this.addProduct({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties,
          },
        ],
      });
    }
  }

  addProduct(formData) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart) {
      formData.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
      formData.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    fetch(`${routes.cart_add_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/javascript",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        // chiudo il configuratore, nascondo l'icona e riattivo lo scroll
        window.ThreeDConfigurator.unmount();
        this.closeConfiguratorBtn.classList.remove("visible");
        this.configuratorWrapper.classList.remove("visible");
        this.html.classList.remove("configurator--visible");

        if (response.status && response.status !== 200) {
          console.error("Cart error", response.message, response.description);
          return;
        }

        if (cart) {
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          // nessun drawer/notification (settings.cart_type == 'page'):
          // stesso comportamento del product form, vai alla pagina carrello
          window.location = window.routes.cart_url;
        }
      })
      .catch((error) => {
        // Fallback chiudi configuratore
        window.ThreeDConfigurator.unmount();
        this.closeConfiguratorBtn.classList.remove("visible");
        this.configuratorWrapper.classList.remove("visible");
        this.html.classList.remove("configurator--visible");
        console.error("Error:", error);
      });
  }

  updateProduct(formData) {
    fetch(`${routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/javascript",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        line: formData.line,
        quantity: 0,
      }),
    })
      .then(() => {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart) {
          formData.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
          formData.sections_url = window.location.pathname;
          cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/javascript",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            // chiudo il configuratore, nascondo l'icona e riattivo lo scroll
            window.ThreeDConfigurator.unmount();
            this.closeConfiguratorBtn.classList.remove("visible");
            this.configuratorWrapper.classList.remove("visible");
            this.html.classList.remove("configurator--visible");

            if (response.status && response.status !== 200) {
              console.error("Cart error", response.message, response.description);
              return;
            }

            if (cart) {
              cart.renderContents(response);
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            } else {
              // nessun drawer/notification (settings.cart_type == 'page'):
              // stesso comportamento del product form, vai alla pagina carrello
              window.location = window.routes.cart_url;
            }
          })
          .catch((error) => {
            // Fallback chiudevide configurazione
            window.ThreeDConfigurator.unmount();
            this.closeConfiguratorBtn.classList.remove("visible");
            this.configuratorWrapper.classList.remove("visible");
            this.html.classList.remove("configurator--visible");
            console.error("Error:", error);
          });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("button-configurator", Configurator);